import React,{useContext} from "react";
import {GameContext} from '../contexts/gameContext';

const MuteButton = ({muted}) => {

    const {setMuted} = useContext(GameContext);

    return (<button className="MuteButton" onClick={e=>setMuted(!muted)}>
        <span className={`fas fa-volume-${muted ? 'mute' : 'up'}`}></span>
    </button>);
}

export default MuteButton;